import { blurImageURL } from "/lib/publicEnv.js";
import Tilt from "react-parallax-tilt";

import { useState } from 'react';

import Image from 'next/image';
import { FaClock, FaCrown } from 'react-icons/fa';
import Link from "next/link";

export default function Thumbnail(props) {
    const [thumbSrc, setThumbSrc] = useState(props.thumb || "/unloaded.png");
    function GetThumbnail() {
        return (
            <>   
                <Image 
                    src={thumbSrc}
                    placeholder="blur" 
                    blurDataURL={blurImageURL.video} 
                    width={3840}
                    height={2160} 
                    layout="fixed"
                    alt={props.title} 
                    className={`object-cover w-full h-full bg-gray-500 text-gray-500`} 
                    style={{ backgroundPosition: "center" }} 
                    unoptimized={props.optimized ? false : true}
                    onLoadingComplete={(i) => {
                        if (i && i.naturalHeight == 90 && i.naturalWidth == 120) {
                            setThumbSrc("/thumbnail.jpg");
                        };
                    }}
                    quality={75}
                />
                <div className="bg-black opacity-[0.5] group-hover:opacity-[0.25] absolute w-full h-full top-0 left-0 transition-all ease-in-out duration-200" />
                <div className="flex flex-col w-full gap-y-4 absolute top-0 left-0 h-full">
                    <div className="flex flex-row justify-between items-center absolute top-0 left-0 mt-4 w-full">
                        <span className="flex flex-rwo gap-x-2 items-center mx-4 text-white text-xl text-center font-bold leading-4 rounded-md z-20">
                            {props.icon && <props.icon className="hover:text-gray-300 text-xl" />} {props.title}
                        </span>
                        <span className="hidden md:flex gap-x-2 items-center mx-4 text-white text-md text-center font-medium leading-4 rounded-md z-20">
                            <FaClock /> {props.cadence}
                        </span>
                    </div>
                    <div className="flex flex-row absolute bottom-0 left-0 mb-4 w-full">
                        {
                            props.tagline && (
                                <span className="flex flex-col gap-y-1 mx-4 text-white text-md text-left font-medium leading-4 rounded-md z-20">
                                    <b>About this job</b> {props.tagline && props.tagline?.slice(0, 41)}{props.tagline?.length >= 42 ? "..." : null}
                                </span>
                            )
                        }
                    </div>
                </div>
            </>
        )
    }

    return (
        <div className="flex flex-col gap-y-3">
            <Link href={props.href} rel="noreferrer" target="_blank" className="rounded-2xl">
                <Tilt tiltEnable={false} glareEnable={false} glareMaxOpacity={0} glarePosition={"all"} perspective={1000} scale={1.05} className="block group relative w-full bg-black transition-all ease-in-out duration-200 rounded-2xl overflow-hidden max-w-[177.78vh] max-h-[56.25vw]">             
                    <GetThumbnail />
                </Tilt>
            </Link>
            <Link href={`/jobs/p/${props.id}`}>
                <div>
                    <div className="flex flex-col gap-y-2">
                        <div className="flex flex-row gap-x-2 items-start">
                            <span className="font-BreezeAltHeader font-medium text-sm flex flex-col">
                                <a href={props.href} rel="noreferrer" target="_blank" className={`font-BreezeAltHeader font-bold hover:text-gray-300 transition-all ease-in-out duration-200`}>{props.none}</a>
                                <div className="flex flex-row gap-x-1 font-semibold">
                                    <a href={props.authorHref} target="_blank" rel="noreferrer noopener"> {
                                    props.authorId === "UCxlyTwuE1uuieLnl_tjBYVQ" ? (
                                        <span className="flex gap-x-1 items-center">
                                            Kooleyy <FaCrown className="text-yellow-400 w-5" />
                                        </span>
                                    ) : props.author
                                    }</a>{props.views ? ` · ${Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 }).format(props.views)} views` : null}
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </Link>
        </div>
    );
};